import { LINKS } from './configureLinks';

export const config: Config = {
  environment: 'PRD',
  features: {
    alpha: false,
    bannerAlerts: false,
  },
  fallbackLocale: 'en',
  sessionTimeoutTriggered: process.env.NODE_ENV === 'production' ? 21420000 : false, // 357 minutes
  sessionTimeoutCountdown: 180000,
  useMock: false,
  cookies: {
    sso: {
      key: 'sso',
      path: LINKS.ROOT,
      domain: '.prosperus.asia',
    },
  },
  endpoints: {
    login: 'https://api.prosperus.asia/sso/api/v1/login/client',
    minVersionAndroid: 'https://api.prosperus.asia/sso/api/v1/minVersion/android',
    minVersionIOS: 'https://api.prosperus.asia/sso/api/v1/minVersion/ios',
    bannerAlerts: 'https://iapi.cgs-cimb.com/prosperus/content/v1/announcements',
    token: 'https://api.prosperus.asia/sso/api/v1/token',
    refreshToken: 'https://api.prosperus.asia/sso/api/v1/token/refresh',
    saxoToken: 'https://api.prosperus.asia/sso/api/v1/saxo/getAccessToken',
    sendSmsOtp: 'https://api.prosperus.asia/sso/api/v1/sendSMSOTP',
    sendLoginSmsOtp: 'https://api.prosperus.asia/sso/api/v1/sendLoginSMSOTP',
    validateLoginSmsOtp: 'https://api.prosperus.asia/sso/api/v1/validateLoginSMSOTP',
    particulars: 'https://api.prosperus.asia/sso/api/v1/user/search',
    userCurrencies: 'https://api.prosperus.asia/sso/api/v1/user/currency',
    updateEmail: 'https://api.prosperus.asia/sso/api/v1/user/updateEmail',
    userPreferences: {
      save: 'https://api.prosperus.asia/sso/api/v1/saveUserPreference',
      load: 'https://api.prosperus.asia/sso/api/v1/getUserPreference',
    },
    mobile: {
      updateMobileRequest: 'https://api.prosperus.asia/sso/api/v1/user/updateMobileRequest',
      sendSmsOtpNewMobileNo: 'https://api.prosperus.asia/sso/api/v1/user/sendSMSOTPNewMobileNo',
      verifySmsOtpNewMobileNo: 'https://api.prosperus.asia/sso/api/v1/user/verifySMSOTPNewMobileNo',
      updateMobile: 'https://api.prosperus.asia/sso/api/v1/user/updateMobile',
    },
    investorSso: 'https://api.prosperus.asia/sso/api/v1/home/investorSAMLResponse',
    traderGoSso: 'https://api.prosperus.asia/sso/api/v1/home/traderGoSAMLResponse',
    externalInvestorApp: 'https://build.prosperus.asia/investor/login.sso.ashx',
    externalTraderGoApp: 'https://boost.prosperus.asia/login.sso.ashx',
    sessionCheck: 'https://api.prosperus.asia/sso/api/v1/login/checkConcurrentLogin',
    logout: 'https://api.prosperus.asia/sso/api/v1/logout/user',
    contactUs: 'https://api.prosperus.asia/sso/api/v1/sendEnquiryEmailNotification/contactUs',
    checkFastAutomation: 'https://api.prosperus.asia/sso/api/v1/checkFastAutomation',
    bankAccount: {
      readAccounts: 'https://api.prosperus.asia/profile/api/v2/bankAccountRequest/getAllBankAccount',
      createAddTicket: 'https://api.prosperus.asia/profile/api/v1/bankAccountRequest/create',
      createRemoveTicket: 'https://api.prosperus.asia/profile/api/v2/bankAccountRequest/delete',
      checkAddTicket: 'https://api.prosperus.asia/profile/api/v2/bankAccountRequest/create/check',
      checkRemoveTicket: 'https://api.prosperus.asia/profile/api/v2/bankAccountRequest/delete/check',
      readTickets: 'https://api.prosperus.asia/profile/api/v1/bankAccountRequest/getAllBankAccountRequest',
      readTicket: 'https://api.prosperus.asia/profile/api/v1/bankAccountRequest/requestDetail',
    },
    funding: {
      createTicket: 'https://api.prosperus.asia/funding/api/v1/fundingRequest/create',
      readTickets: 'https://api.prosperus.asia/funding/api/v1/fundingRequest/transactionHistory',
      readTicket: 'https://api.prosperus.asia/funding/api/v1/fundingRequest/transactionDetail',
    },
    withdrawal: {
      limits: 'https://api.prosperus.asia/withdrawal/api/v1/withdrawalLimit',
      createTicket: 'https://api.prosperus.asia/withdrawal/api/v2/withdrawalRequest',
      readTickets: 'https://api.prosperus.asia/withdrawal/api/v1/withdrawalRequest/transactionHistory',
      readTicket: 'https://api.prosperus.asia/withdrawal/api/v1/withdrawalRequest/transactionDetail',
    },
    w8: {
      getLink: 'https://api.prosperus.asia/sso/api/v1/ew8b/oauth',
      getPreviousSubmissionStatus: 'https://api.prosperus.asia/profile/api/v1/ew8/getSubmissionStatus',
    },
    cka: {
      createTicket: 'https://api.prosperus.asia/profile/api/v1/ckacarForm/submit',
      readTickets: 'https://api.prosperus.asia/profile/api/v1/ckacarForm/getAllCkaCarSubmission',
      readTicket: 'https://api.prosperus.asia/profile/api/v1/ckacarForm/getCkaCarSubmissionDetail',
      getProductStatus: 'https://api.prosperus.asia/profile/api/v1/ckacarForm/getCkaCarStatus',
    },
    marketUpdates: {
      authors: 'https://www.prosperus.asia/wp-json/wp/v2/users',
      categories: 'https://www.prosperus.asia/wp-json/wp/v2/market-categories',
      posts: 'https://www.prosperus.asia/wp-json/wp/v2/market-updates',
      tags: 'https://www.prosperus.asia/wp-json/wp/v2/tags',
      sectors: 'https://www.prosperus.asia/wp-json/wp/v2/sector-tags',
      countries: 'https://www.prosperus.asia/wp-json/wp/v2/country-tags',
      tickers: 'https://www.prosperus.asia/wp-json/wp/v2/ticker-tags',
      media: 'https://www.prosperus.asia/wp-json/wp/v2/media',
    },
    saxo: {
      user: 'https://boost.prosperus.asia/openapi/port/v1/users/me',
      accounts: 'https://boost.prosperus.asia/openapi/port/v1/accounts/me',
      balances: 'https://boost.prosperus.asia/openapi/port/v1/balances/',
      withdrawalLimits: 'https://boost.prosperus.asia/openapi/atr/v1/cashmanagement/withdrawallimits/',
    },
    validation: {
      login: {
        userId: 'https://api.prosperus.asia/sso/api/v1/systemProperties/getUserIdPolicy',
      },
    },
    portfolio: {
      overview: (accountNo: string) => `https://iapi.cgs-cimb.com/prosperus/portfolio/v1/${accountNo}`,
      detail: (accountNo: string) => `https://iapi.cgs-cimb.com/prosperus/portfolio/v1/${accountNo}/detail`,
      privateWealth: 'https://iapi.cgs-cimb.com/prosperus/portfolio/v1/pwealth/',
      privateWealthDetail: 'https://iapi.cgs-cimb.com/prosperus/portfolio/v1/pwealth/detail',
    },
    rewards: {
      redeemable: 'https://iapi.cgs-cimb.com/prosperus/rewards/v1/myrewards',
      type: 'https://iapi.cgs-cimb.com/prosperus/rewards/v1/myrewards/type',
      create: 'https://iapi.cgs-cimb.com/prosperus/rewards/v1/myrewards/create',
      history: 'https://iapi.cgs-cimb.com/prosperus/rewards/v1/myrewards/history',
      detail: 'https://iapi.cgs-cimb.com/prosperus/rewards/v1/myrewards/details',
    },
    announcement: {
      categories: 'https://iapi.cgs-cimb.com/prosperus/content/v1/announcementcategories',
      getAllAnnouncements: 'https://iapi.cgs-cimb.com/prosperus/content/v1/announcements',
      getAnnouncementsById: (id: string) => `https://iapi.cgs-cimb.com/prosperus/content/v1/announcements/${id}`,
    },
  },
  links: {
    ssoPortal: 'https://account.prosperus.asia/SSOPortal/login',
    sgxOnlineEducation: 'https://onlineeducation.sgx.com/specifiedinvestmentproducts/',
    abs: 'https://sips.abs.org.sg/',
    pricing: 'https://www.prosperus.asia/pricing/',
    youtube: {
      channel: 'https://www.youtube.com/channel/UCRs53opRFtmcqjFOi2EmXZg',
      playlist: {
        marketData: 'https://youtu.be/otV7KKQLBZw',
        tradingPlatform: 'https://www.youtube.com/playlist?list=PLnqxcb4_6RIk39qtRRBasMKRi4oHgv7ml',
        whatsNew: 'https://www.youtube-nocookie.com/embed/videoseries?list=PLnqxcb4_6RIm1QzvQC8GVyRc9P09X4RMF',
        tutorial: 'https://www.youtube-nocookie.com/embed/videoseries?v=DNxkBib4OHQ&list=PLnqxcb4_6RIk39qtRRBasMKRi4oHgv7ml',
        investmentTips: 'https://www.youtube-nocookie.com/embed/videoseries?v=G5Ey84bOLHo&list=PLnqxcb4_6RImlW04kPfCS5aLfJAEzluF0',
        webinar: 'https://www.youtube-nocookie.com/embed/videoseries?v=eAT8Jq_M4EE&list=PLnqxcb4_6RIn8hNOMfM29Ku1w99QqU09o',
        investmentInsights: 'https://www.youtube-nocookie.com/embed/videoseries?v=cAnT1xsAT78&list=PLnqxcb4_6RIlK_5kGCOgBgJIgIApxXQxg',
      },
    },
    login: {
      whiteListDomain: 'https://portal.prosperus.asia',
      forgetUserId: 'https://account.prosperus.asia/SSOPortal/login/forgotUserId',
      resetPassword: 'https://account.prosperus.asia/SSOPortal/login/resetPassword',
      register: 'https://account.prosperus.asia/onboarding/',
    },
    termsOfUse: 'https://www.prosperus.asia/terms-of-use/',
    biometricTermsOfUse: 'https://www.prosperus.asia/biometrics-terms-conditions/',
    privacyPolicy: 'https://www.prosperus.asia/privacy-policy/',
    disclaimer: 'https://www.prosperus.asia/disclaimer/',
    rewardsDiclaimer: 'https://account.prosperus.asia/SSOPortal/pdf/RewardsWidgetDisclaimer.pdf',
    irs: 'https://www.irs.gov/individuals/international-taxpayers/taxpayer-identification-numbers-tin',
    iw8ben: 'https://www.irs.gov/forms-pubs/about-form-w-8-ben',
    bursa: 'https://www.bursamalaysia.com/sites/5bb54be15f36ca0af339077a/assets/5bb57d465f36ca0c3028dc96/Transfer_of_Securities_Request-1.pdf',
    sgx: 'https://www.sgxacademy.com/sip/#1575532952967-e5042d40-6b9b',
    boostWindows: 'https://boost.prosperus.asia/download.pro/win?id=CGSSG',
    boostMac: 'https://boost.prosperus.asia/download.pro/mac?id=CGSSG',
    rewardsCatalogue: 'https://www.prosperus.asia/prosperus-club/',
    googlePlaySnackApp: 'https://play.google.com/store/apps/details?id=sg.com.income.snack.prod',
    appStoreSnackApp: 'https://apps.apple.com/sg/app/snack-by-income/id1504035230',
    playStoreApp: 'https://play.google.com/store/apps/details?id=com.cgs.prosperus.sg',
    appStoreApp: 'https://apps.apple.com/sg/app/prosperus-sg/id1566074318',
  },
  uen: '198701621DP01',
  contact: {
    email: {
      default: 'clientservices.sg@cgs-cimb.com',
      sales: 'sg.mgtdsales-engagement@cgs-cimb.com',
      clientServices: 'clientservices.sg@cgs-cimb.com',
      contactUs: 'contactus@prosperus.asia',
    },
    address: {
      line1: '10 Marina Boulevard #09-01',
      line2: 'Marina Bay Financial Centre Tower 2',
      line3: 'Singapore 018983',
    },
    phone: {
      clientFacing: '+65 6210 8868',
      centralExecution: '+65 6232 5888',
    },
  },
  currency: 'SGD',
  zoneNames: {
    marketUpdates: 'Asia/Singapore',
  },
};
